import { render, staticRenderFns } from "./CollectionPanel.vue?vue&type=template&id=18d8ead7&scoped=true"
import script from "./CollectionPanel.vue?vue&type=script&lang=js"
export * from "./CollectionPanel.vue?vue&type=script&lang=js"
import style0 from "./CollectionPanel.vue?vue&type=style&index=0&id=18d8ead7&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d8ead7",
  null
  
)

export default component.exports